import ControlState from '../../Shared/controlState';
import PageState from '../../Shared/pageState';
import { WorkflowEngineState } from '../workflowEngineReducer';

export default (
  state: WorkflowEngineState,
  controlState: ControlState,
  open: boolean
) => {
  state.pages.forEach((page: PageState) => {
    if (page.id === controlState.pageId) {
      page.controls.forEach((control: ControlState) => {
        if (control.id === controlState.id) {
          control.building = open;
          return;
        }
      });
      return;
    }
  });
  return { ...state };
};
